import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { Injectable } from "@angular/core";
import { KYMW7500Model } from "../kymw7500.model";


/**
 * 計画数確認を更新するサービス
 *
 * @export UpdateCheckPlanNumService
 * @class UpdateCheckPlanNumService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateCheckPlanNumService extends PlessJsonResponderSub<undefined> {
  private readonly CHECKED = '1';
  private readonly UNCHECKED = '0';

  private model: KYMW7500Model;
  private successFunc: () => void;
  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   * 
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateCheckPlanNumService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        UpdateGoodsList: {
          condition: {
            OrderCode: this.model.savedSearchParams.orderCode,
            MediumType: this.model.savedSearchParams.mediumType,
          },
          combination: this.model.goodsList.map(goods => ({
            parameter: {
              PCode: goods.pCode,
              CheckFlag: this.model.checkedPCodes.includes(goods.pCode) ? this.CHECKED : this.UNCHECKED
            }
          }))
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateCheckPlanNumService
   */
  execute(model: KYMW7500Model, successFunc?: () => void) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('updateCheckPlanNum', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof UpdateCheckPlanNumService 
   */
  success() {
    if (!!this.successFunc) {
      this.successFunc();
    }
  }
}